export const authenticatorType = {
  KEYCLOAK: 'KEYCLOAK',
};
